angular.module('impactx.rfxsupplier').controller('RFXRFQHFromSupplierCreationCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    '$mdDialog',
    '$redirect',
    RFXRFQHFromSupplierCreationController
]);

function RFXRFQHFromSupplierCreationController($scope, dataGen, TranslationService, $mdDialog, $redirect) {
    var self = this;
    self.wizarIndexConfirmation = 0;
    self.wizarIndexSupplierSelection = 1;
    self.wizarIndexUserSelection = 2;
    self.wizardIndexRFQCSeleciton = 3;

    self.user = {selected: null};
    self.company = {selected: null};
    self.rfqc = {selected: null};
    self.skipWarning = {value: false};
    self.searchTextRFQC = null;
    self.noContractsAvailable = false;
    self.notAllowedContractNames = [];

    dataGen.getData($scope, {}, "/rfx/supplier/createrfqh/overview").then(function () {

        const wizardIndexAfterConfirmation = $scope.data.supplier.entries.length > 1 ? self.wizarIndexSupplierSelection : self.wizarIndexUserSelection;
        $scope.wizardIndex = $scope.data.skipWarning ? wizardIndexAfterConfirmation : self.wizarIndexConfirmation;
        $scope.trns.forward = TranslationService.get("forward");
        $scope.trns.ok = TranslationService.get("ok");
        $scope.trns.abort = TranslationService.get("abort");
        $scope.trns.noSelectedItemMessage = TranslationService.get("noSelectedItemMessage");
        $scope.trns.required = TranslationService.get("required");
    });

    self.onCompanySelect = function (selected) {
        self.validateUserRelationWithCom('comChange', selected);
    };

    self.onUserSelect = function (selected) {
        self.validateUserRelationWithCom('usrChange', selected);
    };

    self.validateUserRelationWithCom = function (mode, selected)
    {
        if(!selected && mode !== 'usrChange') // No infinite change-loops
        {
            self.noContractsAvailable = false;
            self.notAllowedContractNames = [];
            return;
        }
        const params = {comId: self.company.selected ? self.company.selected.id : undefined, usrId: self.user.selected ? self.user.selected.id : undefined};
        if(mode === 'comChange')
        {
            params.comId = selected ? selected.id : 0;
        }
        if(mode === 'usrChange')
        {
            params.usrId = selected ? selected.id : 0;
        }

        if(!params.comId && !params.usrId)
        {
            self.noContractsAvailable = false;
            self.notAllowedContractNames = [];
            return;
        }
        dataGen.getData({}, params, "/rfx/supplier/createrfqh/validateUsrCom").then(function (response)
        {
            if(impactX.isDefined(response, "data.company.id") && response.data.company.id > 0)
            {
                var selectedId = self.company.selected ? self.company.selected.id : undefined;
                if(response.data.company.id !== selectedId) // No infinite change-loops
                {
                    self.company.selected = response.data.company;
                }
            }
            else
            {
                if(mode === 'comChange')
                {
                    self.user.selected = null;
                }
                if(mode === 'usrChange')
                {
                    self.company.selected = null;
                }
            }
            $scope.trns.inactiveRFQC = response.trns.inactiveRFQC;
            $scope.trns.noContractAvailableMessage = response.trns.noContractAvailableMessage;
            $scope.trns.contractAvailableMessage = response.trns.contractAvailableMessage;
            self.noContractsAvailable = response.data.noContractsAvailable;
            self.notAllowedContractNames = response.data.notAllowedContractNames;
        });
    };

    self.selectRFQC = function(entry) {
        if(self.rfqc.selected && entry && self.rfqc.selected.id === entry.id){
            self.rfqc.selected = null;
        }
        else if(entry) {
            self.rfqc.selected = entry;
        }
    };

    self.searchRFQC = function () {
        var paramObj = {
            comId: self.company.selected ? self.company.selected.id : undefined,
            usrId: self.user.selected ? self.user.selected.id : undefined,
            supplierId: $scope.data.supplier.selected.id,
            outletId: $scope.data.outletId,
            searchText: self.searchTextRFQC
        };

        dataGen.getData({}, paramObj, '/rfx/supplier/createrfqh/rfqc').then(function (data) {
            self.rfqc.entries = data.data.entries;
            self.rfqc.additionalEntries = data.data.additionalEntries;
        });
    };

    self.abort = function () {
        $mdDialog.cancel()
    };

    self.forward = function () {
        if ($scope.wizardIndex === self.wizarIndexConfirmation) {
            if (self.skipWarning.value) {
                dataGen.postAsForm({}, {}, "/rfx/supplier/createrfqh/saveskipwarning", false, true);
            }
        }

        var nextWizardIndex = $scope.wizardIndex + 1;
        if (nextWizardIndex === self.wizarIndexSupplierSelection) {
            if ($scope.data.supplier.entries.length <= 1) {
                nextWizardIndex = nextWizardIndex + 1;
            }
            else {
                $scope.wizardIndex = nextWizardIndex;
            }
        }
        if (nextWizardIndex === self.wizarIndexUserSelection) {
            $scope.wizardIndex = nextWizardIndex;
        }
        if (nextWizardIndex === self.wizardIndexRFQCSeleciton) {
            $scope.wizardIndex = nextWizardIndex;
            self.searchRFQC();
        }
        if (nextWizardIndex > self.wizardIndexRFQCSeleciton) {
            var params = {};
            params.supplierId = $scope.data.supplier.selected ? $scope.data.supplier.selected.id : 0;
            params.userId = self.user.selected ? self.user.selected.id : 0;
            params.comId = self.company.selected ? self.company.selected.id : 0;
            params.rfqcId = self.rfqc.selected ? self.rfqc.selected.id : 0;
            params.outletId = $scope.data.outletId;
            dataGen.postAsForm({}, params, "/rfx/supplier/createrfqh").then(function(data){
                $mdDialog.hide();
                $redirect.redirectTo(null, '/rfxsupplier/edit/' + data.data.rfqsId);
            });
        }
    }
}
